import React, { useState } from 'react';
import MortgageCalculator from '../widgets/MortgageCalculator';
import RefinanceCalculator from '../widgets/RefinanceCalculator';
import { brand, theme } from '../widgets/theme';

const WIDGETS = [
  { id: 'mortgage', label: 'Mortgage Calculator', Component: MortgageCalculator },
  { id: 'refinance', label: 'Refinance Calculator', Component: RefinanceCalculator },
];

const LandingPage = () => {
  const [activeWidget, setActiveWidget] = useState(WIDGETS[0].id);

  return (
    <div className="min-h-screen bg-gray-100">
      <header className="text-center py-6">
        <h1 className="text-4xl font-bold text-gray-800 mb-4">{brand.name}</h1>
        <div className="flex justify-center gap-4">
          {WIDGETS.map(({ id, label }) => (
            <button
              key={id}
              className={`px-4 py-2 rounded-md font-medium ${
                activeWidget === id ? theme.toggleActive : theme.tabInactive
              }`}
              onClick={() => setActiveWidget(id)}
            >
              {label}
            </button>
          ))}
        </div>
      </header>

      <div className="flex justify-center">
        <div className="bg-white shadow-md rounded-lg w-full max-w-screen px-0 py-0">
          {WIDGETS.map(({ id, Component }) =>
            activeWidget === id ? <Component key={id} /> : null
          )}
        </div>
      </div>
    </div>
  );
};

export default LandingPage;
